import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import { useLocation } from 'reservations/account/providers/ConfigProvider';
import { useConfig } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import {
  ListItem,
  ListItemContainer
} from 'reservations/base/components/ListItem';
import { HOUR_IN_MILLISECONDS } from 'reservations/base/constants/time';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import { baseGoogleCalendarURL } from 'reservations/preDining/constants';
import { generateIcs, toIsoString } from 'reservations/preDining/helpers';

export const AddToCalendarModal = () => {
  const restaurantName = useRestaurantName();
  const { state, street, city, postal_code } = useLocation();
  const { partySize, dateAndTime, bookingId } = useBookingDetails();
  const { ianaTimeZone } = useConfig();

  const startTime = new Date(dateAndTime);
  const endTime = new Date(startTime.getTime() + HOUR_IN_MILLISECONDS); // Default to 1 hour event

  const eventTitle = `Reservation at ${restaurantName}`;
  const eventAddress = `${street}, ${city}, ${state} ${postal_code}`;
  const eventDescription = `Reservation for ${partySize}`;
  const eventStart = toIsoString(startTime);
  const eventEnd = toIsoString(endTime);

  const googleCalendarParams = new URLSearchParams({
    action: 'TEMPLATE',
    text: eventTitle,
    details: eventDescription,
    location: eventAddress,
    ctz: ianaTimeZone,
    dates: `${eventStart}/${eventEnd}`
  });
  const googleCalendarUrl = `${baseGoogleCalendarURL}${googleCalendarParams.toString()}`;

  const icsContent = generateIcs(
    bookingId,
    eventStart,
    eventEnd,
    eventTitle,
    eventDescription,
    eventAddress,
    ianaTimeZone
  );
  const downloadIcs = () => {
    const blob = new Blob([icsContent], {
      type: 'text/calendar; charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `reservation-${bookingId}.ics`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <BaseDrawer header="Add to calendar">
      <ListItemContainer>
        <ListItem
          primaryLabel="Google Calendar"
          onClick={() =>
            window.open(googleCalendarUrl, '_blank', 'noopener,noreferrer')
          }
        />
        <ListItem
          primaryLabel="Other"
          onClick={() => downloadIcs()}
          includeDivider={false}
        />
      </ListItemContainer>
    </BaseDrawer>
  );
};
